import { EnvironmentService } from "@gtmhub/env";
import { MetricTargetOperator } from "@webapp/okrs/metrics/models/metric.models";
import { IInsightSelectorData, IMarketplaceInsightSuggestedTemplate } from "@gtmhub/insights";
import { IHttpService, IPromise, IRequestShortcutConfig } from "angular";

export interface IMetricPrediction {
  predId: string;
  targetOperator: MetricTargetOperator;
  target?: number;
  format?: { prefix: string; suffix: string; fractionSize: number };
  operatorModelVersion: string;
  targetUnitModelVersion: string;
  initialValue?: number;
  metadata: Map<string, string>;
}

export interface IMetricFieldsChoice {
  metricId: string;
  predId: string;
  title: string;
  operatorSelected: string;
  operatorPredicted: string;
  targetSelected: number;
  targetPredicted: number;
  unitSelected: string | number;
  unitPredicted: string | number;
  unitTypeSelected: string;
  unitTypePredicted: string;
  operatorModelVersion: string;
  targetUnitModelVersion: string;
  initialValuePredicted: number;
  initialValueSelected: number;
  metadata: Map<string, string>;
}

export interface IRecommendedInsight {
  recommendedInsightId: string;
  semanticSimilarityScore: number;
}
export interface IInsightFieldsChoice {
  selectedInsightId: string;
  predictionId: string;
  title: string;
  recommendedInsights: IRecommendedInsight[];
  connectors: string[];
}

export class AutoFieldsService {
  public static $inject = ["$http", "EnvironmentService"];

  constructor(private $http: IHttpService, private env: EnvironmentService) {}

  public getPredictionFromMetric(title: string): IPromise<IMetricPrediction> {
    const url = this.env.getAutoFieldsEndpoint("/metric");
    return this.$http.post<IMetricPrediction>(url, { title }).then((response) => response.data);
  }

  public getInsightRecommendations(title: string): IPromise<IMarketplaceInsightSuggestedTemplate> {
    const url = this.env.getAutoInsightsEndpoint("/recommendation");

    const payload: IRequestShortcutConfig = {
      params: {
        kr: title,
      },
    };

    return this.$http.get<IMarketplaceInsightSuggestedTemplate>(url, payload).then((response) => response.data);
  }

  public sendInsightRecommendtationFeedback(data: IInsightFieldsChoice): IPromise<void> {
    const url = this.env.getAutoInsightsEndpoint("/feedback");
    return this.$http.post<void>(url, data).then((response) => response.data);
  }

  public sendMetricAnalyticsData(data: IMetricFieldsChoice): IPromise<IMetricFieldsChoice> {
    const url = this.env.getAutoFieldsEndpoint("/metric/feedback");
    return this.$http.post<IMetricFieldsChoice>(url, data).then((response) => response.data);
  }

  public getRecommendedInsightAnalyticsData(data: IInsightSelectorData): IInsightFieldsChoice {
    const { id, title } = data.insightTemplate;
    const recommendedInsights = data.suggestedInsights.map((insight) => ({
      recommendedInsightId: insight.id,
      semanticSimilarityScore: insight.semanticSimilarityScore,
    }));
    const connectors = data.suggestedInsights.map((insight) => insight.requiredEntities[0].connector);

    return {
      selectedInsightId: id,
      predictionId: data.predictionId,
      title,
      recommendedInsights: recommendedInsights,
      connectors: connectors,
    };
  }
}
